import { IApplicationState } from '../../types/redux';
import { EUserStatus } from '../../types/newAnswer/userStatus';

export const getUserStatus = (state: IApplicationState): EUserStatus | null => {
  return state.newAnswer.data.userStatus.value;
};
